module.exports = __webpack_public_path__ + "static/media/responsive-web-design.13310374.png";